import React from 'react';
import { Typography, styled, Icon } from '@mui/material';
import { SentimentVeryDissatisfied } from '@mui/icons-material';

const Container = styled('div')(({ theme }) => ({
  justifyContent: 'center',
  gap: 10,
  alignItems: 'center',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
}));

const Content = styled('div')({
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  gap: 5,
});

type NoDataProps = {
  message: string;
  actionscomponent?: React.ReactNode;
};

const NoData: React.FC<NoDataProps> = ({ message, actionscomponent }) => {
  return (
    <Container>
      <Content>
        <Icon fontSize="medium">
          <SentimentVeryDissatisfied fontSize="medium" />
        </Icon>
        <Typography>{message}</Typography>
      </Content>
      {actionscomponent && actionscomponent}
    </Container>
  );
};

export default NoData;
